import type { FC, ReactNode } from "react";

import styled from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";

import type { IConfirmationModalProps } from "./ConfirmationModal";
import { ConfirmationModal } from "./ConfirmationModal";

const FreeText = styled.p`
    color: ${rgba(colorsPalettes.carbon[500], 0.8)};
    font-size: 14px;
    padding-top: 15px;
    min-height: 68px;
`;

const Header = styled.h2`
    line-height: 24px;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
    color: ${colorsPalettes.carbon["500"]};
`;

interface IConfirmationTextModalProps extends IConfirmationModalProps {
    headerText: string;
    contentText: ReactNode;
    extraComponent?: ReactNode;
}

export const ConfirmationTextModal: FC<IConfirmationTextModalProps> = (props) => {
    const { headerText, contentText, extraComponent, ...modalProps } = props;
    return (
        <>
            <ConfirmationModal {...modalProps}>
                <Header>{headerText}</Header>
                <FreeText>{contentText}</FreeText>
            </ConfirmationModal>
            {extraComponent}
        </>
    );
};

ConfirmationTextModal.displayName = "ConfirmationTextModal";
